// Medicare card name helpers (HI-1288).
// The application funnel splits the Medicare name into first / middle / last for input,
// but the backend + Salesforce contract stores a single `medicare_name` string, so we
// recompose on submit and split back on prefill.

// Join the split fields into the single string the API expects.
// e.g. { firstName: 'Annie', middleName: '', lastName: 'Lang' } -> 'Annie Lang'
export const composeMedicareName = ({ firstName = '', middleName = '', lastName = '' } = {}) =>
  [firstName, middleName, lastName]
    .map(part => `${part ?? ''}`.trim())
    .filter(Boolean)
    .join(' ')

// Best-effort split of a stored full name back into the three fields for prefill.
// First token -> first name, last token -> last name, anything in between -> middle name.
export const splitMedicareName = (fullName = '') => {
  const parts = `${fullName ?? ''}`.trim().split(/\s+/).filter(Boolean)

  if (!parts.length) {
    return { firstName: '', middleName: '', lastName: '' }
  }

  if (parts.length === 1) {
    return { firstName: parts[0], middleName: '', lastName: '' }
  }

  const firstName = parts.shift()
  const lastName = parts.pop()

  return { firstName, middleName: parts.join(' '), lastName }
}
